import { fetchInvitations } from '@/api/invitation'
import { useRequiredOrgId } from '@/hooks/useRequiredOrgId'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/query-keys'

export const useInvitations = () => {
  const organizationId = useRequiredOrgId()

  return useQuery({
    queryKey: queryKeys.invitations.all(organizationId),
    queryFn: () => fetchInvitations(organizationId),
    enabled: !!organizationId,
  })
}
